import {isNumber, includes, findIndex, pick} from "lodash";
import {inchesToPixels} from "../lib/Utils";
import {notification} from "antd";

// mimeType - Apache sets this,  Quark does not
// Apache can also use compression - i.e. Quark is only for testing

export function downloadBlob(blob, fileName) {
    let url = window.URL.createObjectURL(blob);

    // Create a fake link and click so we can set the download name
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    link.style ="display: none";
    document.body.appendChild(link);
    link.click();

    // tidyup
    link.remove();
    URL.revokeObjectURL(url);
}

export async function downloadUrl(url, name='file') {
    try {
        window.open(url, "_blank");
    } catch (err) {
        notification.error({
            message: `Download ${name} failed`,
            description: JSON.stringify(err)
        });
    }
}


export function isPureObject(input) {
    return null !== input &&
        typeof input === 'object' &&
        Object.getPrototypeOf(input).isPrototypeOf(Object);
}


//TODO calc size based on area ( with maxWidth & maxHeight)
//TODO !! width & heights are unreliable... convert/check numbers
export function getMaxDimensions(maxSize,{width,height}) {
    //return {};  //TODO broke for web?  smaller than max?

    if (!isNumber(width) || !isNumber(height) || !isNumber(maxSize)) {
        return {maxWidth:maxSize, maxHeight:maxSize};
    }
    return width > height
        ? {
            width: maxSize,
            height: maxSize * height / width
        }
        : {
            width: maxSize * width / height,
            height: maxSize
        };
}

export function getDisplayDimensions(
    {
        unit='', medium='', format='',
        height=0, width=0})
{

    if (! includes(['inches','pixels'], unit.toLowerCase())){
        if (includes(['print','web'], medium.toLowerCase())){
            unit = medium.toLowerCase() === 'web' ? 'pixels' : 'inches';
        } else {
            unit = includes(['png','jpg'], format.toLowerCase()) ? 'pixels' : 'inches';
        }
    }

    return unit.toLowerCase() === 'pixels'
        ? `${inchesToPixels(width)} x ${inchesToPixels(height)}`
        : `${width}" x ${height}"` ;
}

export function getTemplateSize({ad_size='', dimensions='', ...asset}){
    if (!dimensions){
        // todo ? do templates have medium - do we need to construct it?
        //  - web ad_sizes  Or ext
        dimensions = getDisplayDimensions(asset);
    }

    return ad_size + ((ad_size && dimensions) ? " - " : "\u200C") + dimensions;
}


export async function tryNTimes({ toTry, times = 2, interval = 1000}) {
    if (times < 1) throw new Error(`Bad argument: 'times' must be greater than 0, but ${times} was received.`);
    let attemptCount = 0
    while (true) {
        try {
            return await toTry();
        } catch(error) {
            if (++attemptCount >= times) throw error;
        }
        await new Promise(resolve => setTimeout(resolve, interval));
    }
}

export function encodeQueryData(data) {
    const ret = [];
    for (let d in data)
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
    return ret.join('&');
}

// mutates current array
export function replaceElement(arr,rec,prop='id'){
    // Find item index using _.findIndex (thanks @AJ Richardson for comment)
    const index = findIndex(arr, pick(rec,prop));

    // Replace item at index using native splice
    if (index>=0) arr.splice(index, 1, rec);
    return arr;
}

//Keep current page top in view.  (antd Pagination has its own algorythm)
export const calcNewPage = ({newPageSize, pageSize, currentPage})=>{
    const oldFirstRow = calcFirstRow({pageSize,currentPage})
    return Math.floor((oldFirstRow-1) / newPageSize) +1;
}

export const calcFirstRow = ({pageSize, currentPage}) => {
    return pageSize * (currentPage-1) + 1;
}